import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SimpleCaptcha from './SimpleCaptcha';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    topic: '',
    message: ''
  });
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [captchaReset, setCaptchaReset] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleCaptchaValidate = (isValid) => {
    setIsCaptchaValid(isValid);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Validate captcha
    if (!isCaptchaValid) {
      setSubmitStatus('captcha_error');
      setIsSubmitting(false);
      return;
    }

    try {
      // Send email using your backend endpoint
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.topic,
          message: formData.message
        }),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', topic: '', message: '' });
        setIsCaptchaValid(false);
        setCaptchaReset(!captchaReset); // Trigger captcha reset
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className="contact-page">
      <div className="contact-container">
        <Link to="/" className="back-link">← Back to SlimBuddy</Link>
        
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>Have questions, feedback, or need support? We'd love to hear from you!</p>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="your.email@example.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="topic">Topic *</label>
            <select
              id="topic"
              name="topic"
              value={formData.topic}
              onChange={handleChange}
              required
            >
              <option value="">Select a Topic</option>
              <option value="Technical Support">Technical Support</option>
              <option value="Feedback & Suggestions">Feedback & Suggestions</option>
              <option value="Partnership Inquiry">Partnership Inquiry</option>
              <option value="Press & Media">Press & Media</option>
              <option value="Billing & Subscriptions">Billing & Subscriptions</option>
              <option value="Feature Request">Feature Request</option>
              <option value="Bug Report">Bug Report</option>
              <option value="Other">Other</option>
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              placeholder="Please describe your inquiry in detail..."
              rows="6"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <SimpleCaptcha 
            onValidate={handleCaptchaValidate}
            reset={captchaReset}
          />
          
          <button 
            type="submit" 
            className={`submit-btn ${isSubmitting ? 'submitting' : ''}`}
            disabled={isSubmitting || !isCaptchaValid}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>

          {submitStatus === 'success' && (
            <div className="submit-message success">
              ✅ Thank you! Your message has been sent successfully. We'll get back to you within 24 hours.
            </div>
          )}
          
          {submitStatus === 'error' && (
            <div className="submit-message error">
              ❌ Sorry, there was an error sending your message. Please try again or contact us directly at info@slimbuddy.ai
            </div>
          )}

          {submitStatus === 'captcha_error' && (
            <div className="submit-message error">
              ❌ Security verification failed. Please enter the correct captcha code.
            </div>
          )}
        </form>

        <div className="contact-info">
          <p className="direct-contact">
            You can also reach us directly at: <a href="mailto:info@slimbuddy.ai">info@slimbuddy.ai</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;